import React, { useEffect, useState } from "react";
import {
  FaUser,
  FaFileAlt,
  FaFlask,
  FaCheckSquare,
  FaUserClock,
} from "react-icons/fa";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import InputData from "../InputData";
import InspectionGuide from "../InspectionGuide";
import Document from "../Document";
import ManageUsers from "../ManageUsers";
import ManageUsersRequest from "../ManageUsersRequest";
import UploadExcelResults from "../UploadExcelResults";
import AddIndividualData from "../AddIndividualData";
import InspectionGuideDetail from "../InspectionGuideDetail";

//import styles from "./sidebar.module.css";
  
const Sidebar = ({ role, page, subsection, action }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [submenuOpen, setSubmenuOpen] = useState(0);
  const [activeMenu, setActiveMenu] = useState(page);
  const [activeSubMenu, setActiveSubMenu] = useState(subsection);

  const user = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
    if (isOpen) {
      setSubmenuOpen(0);
    }
  };

  const handleMenuClick = (menu) => {
    if (!isOpen) {
      setIsOpen(true);
    }
 
    navigate(`/laboratory/${menu}`);
    setActiveMenu(menu);
    toggleSubmenu(0);
    // setActiveSubMenu("");
  };

  const toggleSubmenu = (name) => {
    setSubmenuOpen((prev) => (prev === name ? 0 : name));
  };
 
  const renderContent = () => {  
    // console.log(
    //   "activeMenu",
    //   activeMenu == "add-individual-data" || page == "add-individual-data"
    // );
    if (page == "inputdata") {
      return <InputData />;
    } else if (page == "inspection-guide") {
      return <InspectionGuide />;
    } else if (page == "document") {
      return <Document />;
    } else if (page == "manageusers") {
      return <ManageUsers />;
    } else if (page == "request-user") {
      return <ManageUsersRequest />;
    } else if (page == "upload-excel-results") {
      return <UploadExcelResults />;
    } else if ( page == "add-individual-data" ) {
      return <AddIndividualData />;
    } else if ( page == "inspection-guide-detail" ) {
      return <InspectionGuideDetail />;
    
    } 
  };

  return (
    <div style={styles.wrapper}>
      <div
        style={{
          ...styles.sidebar,
          width: isOpen ? "263px" : "59px",
        }}
        onMouseEnter={() =>
          isOpen === false && window.innerWidth >= 768 && setIsOpen(true)
        }
        // onMouseLeave={() =>
        //   isOpen === true && window.innerWidth >= 768 && setIsOpen(false)
        // }
      >
        <div
          style={{
            ...styles.header,
            justifyContent: isOpen ? "space-between" : "center",
            padding: isOpen ? "0px 15px 0px 15px" : "",
          }}
        >
          {isOpen &&
            (user?.["auth"]["role"][0] === "LABORATORY_ADMIN" ? (
              <p style={styles.headerText}>สำหรับผู้ดูแลห้องปฏิบัติการ</p>
            ) : (
              <p style={styles.headerText}>สำหรับเจ้าหน้าที่<br/>ห้องปฏิบัติการ</p>
            ))}
          <button
            style={styles.toggleButton}
            onClick={toggleSidebar}
            aria-label={isOpen ? "Close Sidebar" : "Open Sidebar"}
          >
            {isOpen ? (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                -
              </div>
            ) : (
              <div className="flex justify-center items-center text-[30px] w-[40px] h-[40px]">
                +
              </div>
            )}
          </button>
        </div>
        <div style={styles.menu}>
          {/* menu 1 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("inputdata");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor: activeMenu === "inputdata" ? "#00917E" : "",
                color: activeMenu === "inputdata" ? "#fff" : "",
                height: activeMenu === "inputdata" ? "42px" : "",
                borderRadius: activeMenu === "inputdata" ? "6px" : "",
              }}
            >
              <FaCheckSquare style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>ข้อมูลผลการตรวจ</span>}
            </div>
          </div>
          {/* menu 2 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("inspection-guide");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor:
                  activeMenu === "inspection-guide" ? "#00917E" : "",
                color: activeMenu === "inspection-guide" ? "#fff" : "",
                height: activeMenu === "inspection-guide" ? "42px" : "",
                borderRadius: activeMenu === "inspection-guide" ? "6px" : "",
              }}
            >
              <FaFlask style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>แนวทางการตรวจ</span>}
            </div>
          </div>
          {/* menu 3 */}
          <div
            style={styles.menuItem}
            onClick={() => {
              handleMenuClick("document");
              toggleSubmenu(0);
              setActiveSubMenu("");
            }}
          >
            <div
              className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
              style={{
                justifyContent: isOpen ? "start" : "center",
                backgroundColor: activeMenu === "document" ? "#00917E" : "",
                color: activeMenu === "document" ? "#fff" : "",
                height: activeMenu === "document" ? "42px" : "",
                borderRadius: activeMenu === "document" ? "6px" : "",
              }}
            >
              <FaFileAlt style={{ width: "18px" }} />
              {isOpen && <span style={styles.text}>เอกสารที่เกี่ยวข้อง</span>}
            </div>
          </div>
          {/* menu 4 */}
          {user?.["auth"]["role"][0] === "LABORATORY_ADMIN" ? (
            <>
              <div
                style={styles.menuItem}
                onClick={() => {
                  handleMenuClick("manageusers");
                  toggleSubmenu(0);
                  setActiveSubMenu("");
                }}
              >
                <div
                  className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
                  style={{
                    justifyContent: isOpen ? "start" : "center",
                    backgroundColor:
                      activeMenu === "manageusers" ? "#00917E" : "",
                    color: activeMenu === "manageusers" ? "#fff" : "",
                    height: activeMenu === "manageusers" ? "42px" : "",
                    borderRadius: activeMenu === "manageusers" ? "6px" : "",
                  }}
                >
                  <FaUser style={{ width: "18px" }} />
                  {isOpen && (
                    <span style={styles.text}>รายชื่อเจ้าหน้าที่ทั้งหมด</span>
                  )}
                </div>
              </div>
              <div
                style={styles.menuItem}
                onClick={() => {
                  handleMenuClick("request-user");
                  toggleSubmenu(0);
                  setActiveSubMenu("");
                }}
              >
                <div
                  className="flex flex-row items-center gap-[10px] justify-start w-full pl-3 pr-3 active:h-[42px] active:rounded-[6px]"
                  style={{
                    justifyContent: isOpen ? "start" : "center",
                    backgroundColor:
                      activeMenu === "request-user" ? "#00917E" : "",
                    color: activeMenu === "request-user" ? "#fff" : "",
                    height: activeMenu === "request-user" ? "42px" : "",
                    borderRadius: activeMenu === "request-user" ? "6px" : "",
                  }}
                >
                  <FaUserClock style={{ width: "18px" }} />
                  {isOpen && (
                    <span style={styles.text}>
                      รายชื่อผู้ขอย้ายเข้าห้องปฏิบัติการ
                    </span>
                  )}
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

      <div style={styles.container}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "#f4f4f4",
  },
  sidebar: {
    background: "#F5FFFA",
    color: "#00917E",
    transition: "width 0.3s",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
    paddingTop: "10px",
  },
  container: {
    flex: 1,
    position: "relative",
    padding: "20px",
    whiteSpace: "nowrap",
    overflow: "auto",
    backgroundColor: "white",
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: "50px",
  },
  headerText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#00917E",
    //lineHeight: "42px",
    fontFamily: "Prompt, sans-serif",
  },
  toggleButton: {
    background: "#F5FFFA",
    color: "#00917E",
    border: "1px solid #93D3B1",
    borderRadius: "6px",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menu: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    padding: "0 5px",
    justifyContent: "space-between",
    height: "50px",
    cursor: "pointer",
  },
  submenu: {
    borderLeft: "2px solid #93D3B1",
    listStyleType: "disc",
    color: "#00917E",
  },
  submenuItem: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0",
    height: "50px",
    cursor: "pointer",
    transition: "background-color 0.3s",
    margin: "0px 5px",
  },
  submenuItemActive: {
    backgroundColor: "#00917E",
    color: "#fff",
    borderRadius: "6px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "400",
    whiteSpace: "nowrap",
  },
};

export default Sidebar;
